import React, { useState, useEffect } from "react";

const PageWrapper = ({ config, children, onDateFilter }) => {
  // Compute today's and tomorrow's date in YYYY-MM-DD format
  const getLocalDate = (d) => {
    const offset = d.getTimezoneOffset();
    const local  = new Date(d.getTime() - offset * 60 * 1000);
    return local.toISOString().split("T")[0];
  };

  const today    = new Date();
  const tomorrow = new Date();
  tomorrow.setDate(today.getDate() + 1);

  const [startDate, setStartDate] = useState(getLocalDate(today));
  const [endDate,   setEndDate]   = useState(getLocalDate(today)); // ✅ today not tomorrow

  useEffect(() => {
    const timer = setTimeout(() => {
      if (onDateFilter) onDateFilter(getLocalDate(today), getLocalDate(today));
    }, 100);
    return () => clearTimeout(timer);
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (onDateFilter && startDate && endDate) {
      onDateFilter(startDate, endDate);
    }
  };

  return (
    <main>
      <div className="container-fluid">
        {/* Breadcrumb + Date Filter */}
        <div className="row m-1">
          <div className="col-12 justify-content-between align-items-center">
            <div className="card">
              <div className="card-header">
                <h5>{config?.title || "Reports"}</h5>
              </div>
              <div className="card-body">
                <form className="app-form" onSubmit={handleSubmit}>
                  <div className="row g-2 align-items-end">
                    <div className="col-12 col-sm-6 col-md-4 col-lg-3">
                      <div className="mb-2">
                        <label className="form-label fw-semibold f-s-13">From Date</label>
                        <input
                          className="form-control"
                          type="date"
                          value={startDate}
                          onChange={(e) => setStartDate(e.target.value)}
                          required
                        />
                      </div>
                    </div>
                    <div className="col-12 col-sm-6 col-md-4 col-lg-3">
                      <div className="mb-2">
                        <label className="form-label fw-semibold f-s-13">To Date</label>
                        <input
                          className="form-control"
                          type="date"
                          value={endDate}
                          onChange={(e) => setEndDate(e.target.value)}
                          required
                        />
                      </div>
                    </div>
                    <div className="col-12 col-sm-12 col-md-4 col-lg-2">
                      <div className="mb-2">
                        <button className="btn btn-primary w-100 d-inline-flex align-items-center justify-content-center gap-1" type="submit" style={{ height: '38px' }}>
                          <i className="ti ti-filter"></i> Apply Filter
                        </button>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>

        {/* Table Section */}
        <div className="row advance-table-section">
          <div className="col-12">{children}</div>
        </div>
      </div>
    </main>
  );
};

export default PageWrapper;
